if (document.getElementById('page-contents')) {
  page()
}

function page() {
  //  ##   ##  ##     ##   ####  ##   ##  #####   ####  ##  ##
  //  ##   ##  ####   ##  ##     ##   ##  ##     ##     ## ##
  //  ##   ##  ##  ## ##  ##     #######  #####  ##     ####
  //  ##   ##  ##    ###  ##     ##   ##  ##     ##     ## ##
  //   #####   ##     ##   ####  ##   ##  #####   ####  ##  ##

  window.addEventListener('click', function (e) {
    const item = e.target.closest('.js-unCheck')
    if (!item) {
      return
    }
    const target = item.dataset.unCheck
    console.log(target)

    document.querySelector('.js-unCheck--' + target).checked = false
  })
}
